import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Layout, Row, Col, Tabs, Space, Button, Divider } from 'antd'
import theme, { MyTheme } from 'Components/common/Theme'
import Title from 'Components/text/Title'
import { PrimaryButton, RoundButton } from 'Components/button'
import LinkText from 'Components/text/LinkText'
import LogoImage from 'Components/logo/LogoImage'
import Label from 'Components/text/Label'
import { ShopOutlined, UserOutlined } from '@ant-design/icons'
import { appConfig, themeConfig } from 'config'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'

type Props = {
  title?: string
  children: React.ReactNode
  btnText?: string
  onSubmit?: () => void
  isLoginMode?: boolean
  isMerchant?: boolean
  onSwitchMode?: (isMerchantLoginMode: boolean) => void
}

const MerchantsLayout: React.FunctionComponent<Props> = ({
  title = '',
  children,
  btnText = 'เข้าสู่ระบบ',
  onSubmit,
  isLoginMode = true,
  isMerchant = true,
  onSwitchMode = () => {},
}) => {
  const colors = theme.colors
  const breakpoint = useBreakpoint()
  const xs = breakpoint.xs || false
  const getLogo = () => {
    return isMerchant ? (
      <div>
        <ShopOutlined style={{ color: theme.colors.white, fontSize: '30px' }} />
      </div>
    ) : (
      <div>
        <UserOutlined style={{ color: theme.colors.white, fontSize: '30px' }} />
      </div>
    )
  }

  return (
    <MyLayout>
      <MyRow align="middle" justify="center">
        <MyCol md={22} sm={22} xs={22}>
          <Row gutter={[32, 16]}>
            <Col md={12} xs={24}>
              <Space direction="vertical">
                <LogoImage shortLogo={false} width={xs ? 150 : 220} primaryColor={false} />
                <MyTitle color={colors.white}>{themeConfig.title.fullName}</MyTitle>
              </Space>
            </Col>
            <Col md={12} xs={24}>
              <Box>
                <LoginTitle color={colors.primary}>{title}</LoginTitle>
                <ChildBox>{children}</ChildBox>
                <PrimaryButton btnType="Primary" text={btnText} onClick={onSubmit} />
                <ForgotPassword>
                  <Space size="large" align="start">
                    {isLoginMode &&
                      (isMerchant ? (
                        <>
                          <Space direction="vertical" size={'small'} align="end">
                            <Label color={colors.primary}>พนักงานเข้าสู่ระบบ {''}</Label>
                            <LinkText color={colors.primary} onClick={() => onSwitchMode(false)}>
                              คลิกที่นี่
                            </LinkText>
                          </Space>
                          <Line />
                        </>
                      ) : (
                        <>
                          <LinkText color={colors.primary} onClick={() => onSwitchMode(true)}>
                            กลับไปหน้าเข้าสู่ระบบสำหรับร้านค้า
                          </LinkText>
                        </>
                      ))}
                    {isLoginMode ? (
                      isMerchant && (
                        <Link to="/reset">
                          <LinkText color={colors.primary}>ลืมรหัสผ่าน</LinkText>
                        </Link>
                      )
                    ) : (
                      <Link to="/">
                        <LinkText color={colors.primary}>กลับไปหน้าเข้าสู่ระบบ</LinkText>
                      </Link>
                    )}
                  </Space>
                </ForgotPassword>
              </Box>
            </Col>
          </Row>
        </MyCol>
      </MyRow>
      <VersionWrapper>
        <span>version {appConfig.version || '0'}</span>
      </VersionWrapper>
    </MyLayout>
  )
}

const MyLayout = styled(Layout)`
  background: ${(props: { theme: MyTheme }): string => props.theme.colors.backgroundGradient};
  height: 100vh;
`

const MyRow = styled(Row)`
  height: 100vh;
`

const MyCol = styled(Col)`
  text-align: center;
`

const MyTitle = styled.h2`
  display: inline-block;
  box-sizing: border-box;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
  opacity: 0.8;
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.medium};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.h4};
  @media only screen and (min-width: 1024px) {
    font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.h3};
  }
  white-space: pre-wrap;
  @media only screen and (max-width: 670px) {
    font-size: 16px !important;
  }
`

const LoginTitle = styled(Title)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary} !important;
  font-size: 35px;
`

const Box = styled.div`
  width: 100%;
  max-width: 580px;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
  border-radius: 15px;
  padding: 50px 100px 50px 100px;
  border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.primary};

  @media only screen and (max-width: 670px) {
    padding: 20px;
  }
`

const ForgotPassword = styled.div`
  margin-top: 30px;
`

const ChildBox = styled.div`
  //margin-top: 30px;
`

const VersionWrapper = styled.div`
  margin-top: 10px;
  padding-bottom: 10px;
  text-align: center;
  color: #ddd;
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.caption};
`

const Line = styled.div`
  border-right: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  height: 50px;
`

export default MerchantsLayout
